<div aria-live="assertive" class="pointer-events-none fixed inset-0 z-10 flex items-end px-4 py-6 sm:items-start sm:p-6">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <div
      class="bg-sap-background-white outline-sap-border pointer-events-auto w-full max-w-sm translate-y-0 transform rounded-lg opacity-100 shadow-lg outline-1 -outline-offset-1 transition duration-300 ease-out sm:translate-x-0 starting:translate-y-2 starting:opacity-0 starting:sm:translate-x-2 starting:sm:translate-y-0"
    >
      <div class="p-4">
        <div class="flex items-start">
          <div class="shrink-0 pt-0.5">
            <div class="bg-sap-primary-lighter-blue text-sap-primary-blue flex size-10 items-center justify-center rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
                />
              </svg>
            </div>
          </div>
          <div class="ml-3 w-0 flex-1">
            <p class="text-sap-text-title text-sm font-medium">A new version is available!</p>
            <p class="text-sap-blueish-gray mt-1 text-sm">Click 'Update' to update now.</p>
            <div class="mt-4 flex">
              <button
                type="button"
                class="bg-sap-primary-blue hover:bg-sap-dark-blue focus-visible:outline-sap-primary-blue inline-flex items-center rounded-md px-2.5 py-1.5 text-sm font-semibold text-white focus-visible:outline-2 focus-visible:outline-offset-2"
                (click)="activateUpdate()"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
